import * as React from 'react'

import '../styles/JobDetails.scss'

import { ListItem } from 'material-ui/List'
import * as moment from 'moment'
// tslint:disable-next-line:no-duplicate-imports
import { Moment } from 'moment'
import { StringResources } from '../localization/StringResources';
import { Strings } from '../localization';
import {getFormatedPrice} from '../utils/PricingUtils'

export interface HaulerInfo {
  company: string
  avatar: string
  price: number | null
  completed: Date | Moment | undefined
  enabledIndependent: boolean
  haulerName: string
}

interface CompletedJobDetailProps {
  haulerInfo: HaulerInfo
}

export class JobDetails extends React.Component<CompletedJobDetailProps, {}> {
  constructor(props: any) {
    super(props)
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.haulerInfo !== nextProps.haulerInfo) {
      this.setState({
        haulerInfo: nextProps.haulerInfo
      })
    }
  }

  render() {
    return (
      <div className="hauler-review">
        <ListItem
          className="job-details-list-item"
          disabled={true}
          leftAvatar={
            <div className="hauler-avatar-review">
              <img src={this.props.haulerInfo.avatar} />
            </div>
          }
          primaryText={
            <div className="primary-text-review">
              {this.props.haulerInfo.enabledIndependent ? this.props.haulerInfo.haulerName : this.props.haulerInfo.company}
            </div>
          }
          secondaryText={
            <div className="secondary-text-review">
              <div><p>{StringResources.getString(Strings.Components.JobDetails.Paragraphs.Completed)}</p><span>{this.props.haulerInfo.completed ? moment(this.props.haulerInfo.completed).format('MM/DD/YYYY h:mm A') : ''}</span></div>
              <div>
                <p>{StringResources.getString(Strings.Components.JobDetails.Paragraphs.Price)}</p>
                <span>${this.props.haulerInfo.price !== null && getFormatedPrice(this.props.haulerInfo.price)}</span>
              </div>
            </div>
          }
          secondaryTextLines={2}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/JobDetails.tsx